"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* [DISABLED_TEMPORARILY] @ typescript-eslint /camelcase */
var textLinksConfig = [
    {
        key: 'titleText',
        type: 'string',
        label_ar: 'Title text',
        label_en: 'Title text',
        required: false,
        sort: 1,
    },
    {
        key: 'summaryText',
        type: 'string',
        label_ar: 'Subtitle text',
        label_en: 'Subtitle text',
        required: false,
        sort: 2,
    },
    {
        key: 'links',
        type: 'array',
        label_ar: 'Links',
        label_en: 'Links',
        required: true,
        is_virtual: false,
        sort: 3,
        values: [
            {
                key: 'linkText',
                type: 'string',
                label_ar: 'Link Text',
                label_en: 'Link Text',
                required: true,
                sort: 1,
            },
            {
                key: 'linkUrl',
                type: 'url',
                label_ar: 'Link Url',
                label_en: 'Link Url',
                description_en: 'The URL may look more generic after saving, but it will point to the same page',
                description_ar: 'The URL may look more generic after saving, but it will point to the same page',
                required: false,
                sort: 2,
            },
        ],
    },
    {
        key: 'bgColor',
        type: 'color',
        label_ar: 'Background Color',
        label_en: 'Background Color',
        required: false,
        default_value: '#FFFFFF',
        is_virtual: false,
        sort: 4,
    },
    // Virtual as no use for this yet as not looking into analysis
    {
        key: 'widgetId',
        type: 'number',
        label_ar: 'Widget ID',
        label_en: 'Widget ID',
        required: false,
        is_virtual: true,
    },
];
exports.default = textLinksConfig;
//# sourceMappingURL=config.js.map